import React, {useState} from 'react';

import {useMediaQueries} from 'presentation/pages/private/hooks';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';

import {ModalProps} from './types';
import {ExamInfo} from './store/useExamOrientationsInfoStore/types';
import {ExamOrientationsDrawer} from './components/ExamOrientationsDrawer';
import {ExamOrientationsModal} from './components/ExamOrientationsModal';

export const ExamOrientationsDialog = ({open, setOpen, handleAgree}: ModalProps) => {
	const {isMobile} = useMediaQueries();
	const [checked, setChecked] = useState(false);

	function handleToggleCheckbox() {
		setChecked(prev => !prev);
	}

	function handleOnClose() {
		setOpen(false);
		setChecked(false);
	}

	function handleOnAgree(examInfo: ExamInfo) {
		setChecked(false);
		handleAgree(examInfo);
	}

	if (isMobile) {
		return (
			<ExamOrientationsDrawer
				open={open}
				onClose={handleOnClose}
				onToggleCheckbox={handleToggleCheckbox}
				checked={checked}
				handleAgree={handleOnAgree}
				dataTagIdInfo={AppointmentBookingEnum.VISUALIZOU_ORIENTACOES_EXAME}
				dataTagIdButton={AppointmentBookingEnum.CONFIRMOU_ORIENTACOES_EXAME}
			/>
		);
	}

	return (
		<ExamOrientationsModal
			open={open}
			onClose={handleOnClose}
			onToggleCheckbox={handleToggleCheckbox}
			checked={checked}
			handleAgree={handleOnAgree}
			dataTagIdInfo={AppointmentBookingEnum.VISUALIZOU_ORIENTACOES_EXAME}
			dataTagIdButton={AppointmentBookingEnum.CONFIRMOU_ORIENTACOES_EXAME}
		/>
	);
};
